var map = {
	"./activity-calculate.svg": 46214,
	"./activity-consider.svg": 24135,
	"./activity-discuss.svg": 47788,
	"./activity-evaluate.svg": 939,
	"./activity-explore.svg": 55015,
	"./activity-rolePlay.svg": 51004,
	"./activity-write.svg": 74199,
	"./ahoy-duration.svg": 88066,
	"./ahoy-huh.svg": 49902,
	"./ahoy-like.svg": 95915,
	"./ahoy-sad.svg": 13546,
	"./ahoy-uniques.svg": 12318,
	"./ahoy-views.svg": 92736,
	"./ahoy-wow.svg": 77319,
	"./back.svg": 38719,
	"./comments-close.svg": 61871,
	"./consider.svg": 95771,
	"./dashboard-delete.svg": 43234,
	"./dashboard-done.svg": 215,
	"./dashboard-edit.svg": 50047,
	"./edgenote-aside.svg": 89930,
	"./edgenote-audio.svg": 89968,
	"./edgenote-graphic.svg": 36702,
	"./edgenote-link.svg": 93578,
	"./edgenote-photo.svg": 97178,
	"./edgenote-quote.svg": 26294,
	"./edgenote-report.svg": 45652,
	"./edgenote-video.svg": 20383,
	"./explore.svg": 43987,
	"./file-audio.svg": 15281,
	"./file-basic.svg": 60301,
	"./file-code.svg": 28226,
	"./file-data.svg": 45725,
	"./file-image.svg": 88956,
	"./file-model.svg": 65892,
	"./file-shapes.svg": 94291,
	"./file-spreadsheet.svg": 38041,
	"./file-tasks.svg": 39509,
	"./file-text.svg": 62656,
	"./file-video.svg": 18934,
	"./link.svg": 66666,
	"./listen.svg": 97387,
	"./loading.svg": 28886,
	"./modal-close.svg": 81030,
	"./pin.svg": 78884,
	"./read.svg": 69162,
	"./repond.svg": 82136,
	"./respond.svg": 27261,
	"./toc-podcast.svg": 90887,
	"./toc-roleplay.svg": 19595,
	"./trash.svg": 72252,
	"./wikidata-logo.svg": 61198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50352;